const fn = {

    init: () => {

        const toggle = document.getElementById('mobile-menu-toggle');
        const close = document.getElementById('mobile-menu-close');
        const overlay = document.getElementById('mobile-menu-overlay');

        toggle.addEventListener('click', fn.openMenu);
        close.addEventListener('click', fn.closeMenu);
        overlay.addEventListener('click', fn.closeMenu);

        // Optional: close on Escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') fn.closeMenu();
        });
    },

    openMenu: () => {
        const menu = document.getElementById('mobile-menu')
        const overlay = document.getElementById('mobile-menu-overlay')
        menu.classList.remove('translate-x-full');
        menu.classList.add('translate-x-0');
        overlay.classList.remove('hidden');
        menu.focus();
        document.body.style.overflow = 'hidden';
    },

    closeMenu: () => {
        const menu = document.getElementById('mobile-menu')
        const overlay = document.getElementById('mobile-menu-overlay')
        menu.classList.add('translate-x-full');
        menu.classList.remove('translate-x-0');
        overlay.classList.add('hidden');
        document.body.style.overflow = '';
    }

}

export default {
    can: () => document.querySelectorAll('.mobile-nav').length > 0,
    run: fn.init,
}
